import { Contract } from '@ethersproject/contracts';
import { Provider } from '@ethersproject/providers';
import { Signer } from '@ethersproject/abstract-signer';
export { contracts } from '@r3l/common/lib/contracts';

let signerOrProvider: Signer;

export const getSigner = (): Signer => signerOrProvider;
export const setSignerOrProvider = (_signerOrPrivder: Signer): Signer =>
  (signerOrProvider = _signerOrPrivder);

export const getContract = (
  address: string,
  abi: any,
  signerOrProvider: Provider | Signer
): Contract | undefined => {
  return new Contract(address, abi, signerOrProvider);
};
